import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { QuestionDto } from '@api/models/questionnaire/QuestionDto';
import { questionnaireVersionService } from '@api/services/services';

type State = BaseType<QuestionDto[]>;

const initialState: State = {
  state: FetchState.None,
  data: [],
};

export const questionnaireQuestionsSlice = baseSlice({
  name: 'questionnaireQuestions',
  initialState,
});

export const selectQuestionnaireQuestionsState = (state: RootState) => state.questionnaireQuestions.state;
export const selectQuestionnaireQuestions = (state: RootState) =>
  state.questionnaireQuestions.data.slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
export const questionnaireQuestionsActions = questionnaireQuestionsSlice.actions;

export const getQuestionnaireQuestions = (questionnaireVersionId: string, languageCode: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return questionnaireVersionService.getQuestions(questionnaireVersionId, languageCode);
  };

  getItem({
    dispatch,
    actions: questionnaireQuestionsActions,
    getData: handleGetData,
  });
};
